import { Component } from '@angular/core';
import { SITE_DATA } from '../../../app/productization/default.constant';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { RouterLink } from '@angular/router';
@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    imports: [NzGridModule, RouterLink]
})
export class FooterComponent {
	public currentYear: number = new Date().getFullYear();
	public siteData: any = SITE_DATA;
}
